import { getCarsCount, GetCarsCountResponse } from 'api/cars'
import { createEffect, createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'

import { useAVNConfig } from '../../../stages/AVN'
import { FilterValues } from '../../filter/types'
import { RoutingPanelFeatureProps as RoutingPanelProps } from '../types'
import { createId } from './utils'

export const $routingPanelGate = createGate<RoutingPanelProps>()

/**
 * Число машин, которые будут найдены после применения фильтра
 */
export const $carsCount = createStore<null | { id: string; count: number }[]>(null)

/**
 * Загружается ли число машин
 */
export const $fetchingCarsCount = createStore(true)

export const $routingPanelData = createStore(<GetCarsCountResponse>{})
const trigger = createEvent<GetCarsCountResponse>()
$routingPanelData.on(trigger, (_, data) => data)

/**
 * Получить число машин для карточек
 */
type GetCarsCountFxProps = {
  cities: string[]
  routingPanel: RoutingPanelProps
}

export const getCarsCountFx = createEffect(async (options: GetCarsCountFxProps) => {
  let counts: any[]
  let res: any[] = []
  if (options.routingPanel.useBackendFilter) {
    const dataRoutingPanel = await getCarsCount({
      url: options.routingPanel.getFilterUrl,
      filter: options.routingPanel.filter as FilterValues,
      cities: options.cities.filter((item) => item !== '')
    })
    trigger(dataRoutingPanel)
    dataRoutingPanel.cards?.map((item) => {
      res.push({
        count: item.quantity
      })
    })
    return dataRoutingPanel.cards?.map((card, index) => ({
      id: createId(card),
      count: res[index].count
    }))
  } else {
    counts = options.routingPanel.cards.map((card) => {
      return getCarsCount({
        url: options.routingPanel.getCarsCountUrl,
        filter: card.filter as FilterValues,
        cities: options.cities.filter((item) => item !== '')
      })
    })
    res = await Promise.all(counts)
    return options.routingPanel.cards.map((card, index) => ({
      id: createId(card),
      count: res[index].count
    }))
  }
})
